const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Si el endpoint necesita un ID u otro parámetro, lo pedimos como función (bookDetails(bookId)).
const apiRoutes = {
    // Users
    saveUserApi: `${BASE_URL}/saveUser`,
    // Bookcases
    mostPopularShelfApi: `${BASE_URL}/popularBooks`,
    bookVisitedApi: `${BASE_URL}/visited_book`,
    // Book
    bookInfoApi: `${BASE_URL}/book_info`,
    // Chapter
    chapterApi: (chapterHash) => `${BASE_URL}/chapter/${chapterHash}`,
    chapterAudioApi: (dialectCode, chapterHash) => `${BASE_URL}/dialect/${dialectCode}/chapter/${chapterHash}`, 
    bookFiles: `${BASE_URL}/storage/book_files/`,
    // Lemmas
    apiUrlLemma: `${BASE_URL}/lemma/`,
    apiUrlDendritic: (morfema) => `${BASE_URL}/dendritic/${morfema}`,
    // Preferences
    apiUrlUpdatePreferences: `${BASE_URL}/updatePreferences`,
    // Chaper finished
    apiUrlChapterFinished: `${BASE_URL}/chapterFinished`,
    // BookCover
    apiUrlBookCover: (bookId) => `${BASE_URL}/books_files/${bookId}/cover.png`,
    // Reading list
    readingList: `${BASE_URL}/reading_list`,
    readingListItem: (bookId) => `${BASE_URL}/reading_list/${encodeURIComponent(bookId)}`,
    // Ambient
    ambientTracks: `${BASE_URL}/ambient-tracks`,
    ambientFiles: `${BASE_URL}/storage/ambient/`,
    // Search books
    searchBooks: (query, options = {}) => {
        const safeQuery = typeof query === "string" ? query : "";
        const params = new URLSearchParams();
        if (options.language) params.set("lang", options.language);
        if (options.category) params.set("category", options.category);
        if (options.limit) params.set("limit", options.limit);

        const queryString = params.toString();
        const endpoint = `${BASE_URL}/search/books/${encodeURIComponent(safeQuery)}`;
        return queryString ? `${endpoint}?${queryString}` : endpoint;
    },


    /* Others: */
    apiFeedback: `${BASE_URL}/feedback`,
    apiFeedbackNoRegistration: `${BASE_URL}/feedbackNoRegistration`,
  
};

export default apiRoutes;
